import { Typography } from '@material-tailwind/react'
import { PiProhibitInset } from 'react-icons/pi'
import { useTranslation } from 'react-i18next'

const Unauthorized = () => {
  const { t } = useTranslation()

  return (
    <div className="w-full flex flex-col justify-between items-start md:items-center py-4 gap-4">
      <div className="flex justify-center items-end gap-4">
        <PiProhibitInset className="w-7 h-7 text-accent-red-700 dark:text-accent-red-500" />
        <Typography variant="h3" className="text-accent-red-700 dark:text-accent-red-500">
          {t('unauthorized.title')}
        </Typography>
      </div>
      <Typography className="font-bold">{t('unauthorized.description')}</Typography>
    </div>
  )
}

export default Unauthorized
